import './single.scss';
import React, {useState, useEffect, useContext, useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import {Document, Page, pdfjs} from 'react-pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import {useReactToPrint} from 'react-to-print';
import {
    doc,
    getDoc,
    collection,
    onSnapshot,
  } from "firebase/firestore";
import { db } from "../../../firebase";
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import Navbar1 from '../../main/Navbar1';
import Sidebar from '../components/sidebar/Sidebar';
pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
const Single = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const componentRef = useRef();
    let [firstRender, setFirstRender] = useState({
        firstRender: true,
    });
    const [fileList, setFileList] = useState([]);

    const { usr, isError, isSuccess, message} = useSelector(
        (state) => state.auth
      )

    const [user, setUser] = useState({
        id: '',
        title : '',
        grade : '',
        lastName: '',
        firstName: '',
        email: '',
        phone: '',
        whatsapp: ''
    });

    const [step1, setStep1] = useState({
        lastName: '',
        firstName: '',
        birthday: '',
        gender: '',
        specialty: '',
        structure: '',
        diplome: '',
        mbr1Name: '',
        mbr1Title: '',
        mbr1Grade: '',
        mbr1Specialty: '',
        mbr1Gender: '',
        mbr2Name: '',
        mbr2Title: '',
        mbr2Grade: '',
        mbr2Specialty: '',
        mbr2Gender: '',
        mbr3Name: '',
        mbr3Title: '',
        mbr3Grade: '',
        mbr3Specialty: '',
        mbr3Gender: '',
        theme: ''
    });

    const [step2, setStep2] = useState({
        title : '',
        titleShort : '',
        resume: '',
        context: '',
        objective: '',
        result: '',
        amount: '',
        duration : ''
    });

    const [step3, setStep3] = useState({
        state : '',
        description : '',
        advantages: '',
        materials: '',
        methodology: ''
    });

    const [step4, setStep4] = useState({
        activities : '',
        calendarUrl : '',
        matrixUrl: '',
        budgetUrl: ''
    });

    const [step5, setStep5] = useState({
        means : '',
        patentNumber : '',
        patentManagement: ''
    });

    const [step6, setStep6] = useState({
        publishings : '',
        patents : ''
    });

    const [step7, setStep7] = useState({
        img : '',
        timeStamp: null
    });

    const [step8, setStep8] = useState({
        partner: '',
        img : '',
        timeStamp: null
    });

    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    const getUserDetails = async () => {
        try {
            const userRef = doc(db, "users", id);
            const userSnap = await getDoc(userRef);
            
            if(userSnap.exists()){
            return userSnap.data();
            }
            else{
            return null;
            }
        } catch (error) {
            console.log(error)
        }
    };

    // get step details
    const getStep1Details = async () => {
        try {
            const stepRef = doc(db, "step1", id);
            const stepSnap = await getDoc(stepRef);
            
            if(stepSnap.exists()){
            return stepSnap.data();
            }
            else{
            return null;
            }
        } catch (error) {
            console.log(error)
        }
    };

    const getStep2Details = async () => {
        try {
            const stepRef = doc(db, "step2", id);
            const stepSnap = await getDoc(stepRef);
            
            if(stepSnap.exists()){
            return stepSnap.data();
            }
            else{
            return null;
            }
        } catch (error) {
            console.log(error)
        }
    };

    const getStep3Details = async () => {
        try {
            const stepRef = doc(db, "step3", id);
            const stepSnap = await getDoc(stepRef);
            
            if(stepSnap.exists()){
            return stepSnap.data();
            }
            else{
            return null;
            }
        } catch (error) {
            console.log(error)
        }
    };

    const getStep4Details = async () => {
        try {
            const stepRef = doc(db, "step4", id);
            const stepSnap = await getDoc(stepRef);
            
            if(stepSnap.exists()){
            return stepSnap.data();
            }
            else{
            return null;
            }
        } catch (error) {
            console.log(error)
        }
    };

    const getStep5Details = async () => {
        try {
            const stepRef = doc(db, "step5", id);
            const stepSnap = await getDoc(stepRef);
            
            if(stepSnap.exists()){
            return stepSnap.data();
            }
            else{
            return null;
            }
        } catch (error) {
            console.log(error)
        }
    };

    const getStep6Details = async () => {
        try {
            const stepRef = doc(db, "step6", id);
            const stepSnap = await getDoc(stepRef);
            
            if(stepSnap.exists()){
            return stepSnap.data();
            }
            else{
            return null;
            }
        } catch (error) {
            console.log(error)
        }
    };

    const getStep7Details = async () => {
        try {
            const stepRef = doc(db, "step7", id);
            const stepSnap = await getDoc(stepRef);
            
            if(stepSnap.exists()){
            return stepSnap.data();
            }
            else{
            return null;
            }
        } catch (error) {
            console.log(error)
        }
    };

    const getStep8Details = async () => {
        try {
            const stepRef = doc(db, "step8", id);
            const stepSnap = await getDoc(stepRef);
            
            if(stepSnap.exists()){
            return stepSnap.data();
            }
            else{
            return null;
            }
        } catch (error) {
            console.log(error)
        }
    };

    const getAllDetails = async () => {
        getFileList();
        await getUserDetails().then(data => {
            if(data != null){
                setUser(data);
            }
        });
        await getStep1Details().then(data => {
            if(data != null){
                setStep1(data)
            }
        });
        await getStep2Details().then(data => {
            if(data != null){
                setStep2(data)
            }
        });
        await getStep3Details().then(data => {
            if(data != null){
                setStep3(data)
            }
        });
        await getStep4Details().then(data => {
            if(data != null){
                setStep4(data)
            }
        });
        await getStep5Details().then(data => {
            if(data != null){
                setStep5(data)
            }
        });
        await getStep6Details().then(data => {
            if(data != null){
                setStep6(data);
            }
        });
        await getStep7Details().then(data => {
            if(data != null){
                setStep7(data)
            }
        });
        await getStep8Details().then(data => {
            if(data != null){
                setStep8(data)
            }
        });
    };

    const getFileList = async () => {
        try {
            const unsub = onSnapshot(
                collection(db, `submissions/${user.id}/documents`),
                (snapShot) => {
                  let list = [];
                  snapShot.docs.forEach((doc) => {
                    list.push({ id: doc.id, ...doc.data() });
                  });
                  setFileList(list);
                },
                (error) => {
                  console.log(error);
                }
              );
          
              return () => {
                unsub();
            };
        } catch (error) {
            console.log(error)
        }
    };
    
    useEffect(() => {
    
        // getting user details
        
        if(firstRender){
            getAllDetails().then(() => {
                setFirstRender(false);
            });
        }

        if (isError) {
        toast.error(message)
        }

        if (isSuccess || usr) {
            navigate("/step1")
        }
  }, [user, isError, isSuccess, message, firstRender, dispatch])

    // Handle Submit
    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    return (
        <div className='home'>
            <Sidebar/>
            <div className="homeContainer">
            <Navbar1/>
            <div className="container my-5 ml-5">
                <div ref={componentRef} className='m-4'>
                                    <br/>
                                    <div className="d-flex justify-content-between banner">
                                        <img src="/assets/partners/KONGO.png" alt="About" className="img-banner pe-2"/>
                                        <img src="/assets/partners/EDENAFRICA.png" alt="About" className="img-banner pe-2"/>
                                        <img src="/assets/partners/EWB.png" alt="About" className="img-banner pe-2"/>
                                        <img src="/assets/partners/IFDD.png" alt="About" className="img-banner pe-2"/>
                                        <img src="/assets/logo.png" alt="About" className="img-banner"/>
                                    </div>
                                    <br/><br/>
                                    <div className="banner">
                                        <h1 className="mb-4 fw-bolder text-center title">APAFReP</h1>
                                        <p className="mb-4 text-center">{t('banner_title')}</p>
                                    </div>
                                    <table className='banner'>
                                        <tr>
                                            <td className='step-title first'>
                                            <p>{t('step_0')}</p>
                                            </td>
                                            <td className='step-item-title'>
                                                <tr>
                                                    <div className="lead first">{t('step_0_text')}</div>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={user.title.length < 1?
                                                                'error'
                                                                    :
                                                                'fw-bolder'
                                                            }>{t('title')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {user.title}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={user.grade.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>Grade</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {user.grade}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={user.lastName.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('names')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {user.lastName}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={user.firstName.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('first_names')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {user.firstName}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={user.email.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('email_address')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {user.email}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={user.phone.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('phone')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {user.phone}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={user.whatsapp.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>Whatsapp </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {user.whatsapp}
                                                    </td>
                                                </tr>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='step-title'>
                                                <p>{t('step_1')}</p>
                                            </td>
                                            <td className='step-item-title'>
                                                <tr>
                                                    <div className="lead">{t('step_1_text')}</div>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.lastName.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('project_leader_name')}  </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.lastName}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.firstName.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('project_leader_first_name')}  </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.firstName}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.birthday.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('birth_day')}  </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.birthday}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.gender.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('gender')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.gender}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.specialty.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('specialty')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.specialty}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.structure.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('assignment_structure')}  </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.structure}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.diplome.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('highest_diploma')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.diplome}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <div className="lead first px-3">{t('project_team_presentation')}</div>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <div className="px-4">- {t('member')} 1</div>
                                                        <span className={step1.mbr1Name.length < 1?
                                                                'error'
                                                                    :
                                                                'fw-bolder'
                                                            }>{t('first_last_name')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr1Name}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.mbr1Title.length < 1?
                                                                'error'
                                                                    :
                                                                'fw-bolder'
                                                            }>{t('title')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr1Title}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.mbr1Grade.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>Grade</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr1Grade}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.mbr1Specialty.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('specialty')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr1Specialty}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.mbr1Gender.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('gender')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr1Gender}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <div className="px-4">- {t('member')} 2</div>
                                                        <span className='fw-bolder'>{t('first_last_name')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr2Name}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className='fw-bolder'>{t('title')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr2Name.length > 1 ? step1.mbr2Title : '' }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className='fw-bolder'>Grade</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr2Name.length > 1 ? step1.mbr2Grade : '' }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className='fw-bolder'>{t('specialty')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr2Name.length > 1 ? step1.mbr2Specialty : '' }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className='fw-bolder'>{t('gender')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr2Name.length > 1 ? step1.mbr2Gender : '' }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <div className="px-4">- {t('member')} 3</div>
                                                        <span className='fw-bolder'>{t('first_last_name')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr3Name}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className='fw-bolder'>{t('title')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr3Name.length > 1 ? step1.mbr3Title : '' }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className='fw-bolder'>Grade</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr3Name.length > 1 ? step1.mbr3Grade : '' }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className='fw-bolder'>{t('specialty')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr3Name.length > 1 ? step1.mbr3Specialty : '' }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className='fw-bolder'>{t('gender')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.mbr3Name.length > 1 ? step1.mbr3Gender : '' }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step1.theme.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>- {t('theme')}</span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step1.theme}
                                                    </td>
                                                </tr>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='step-title'>
                                                <p>{t('step')} 2</p>
                                            </td>
                                            <td className='step-item-title'>
                                                <tr>
                                                    <div className="lead">{t('step_2_text')}</div>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step2.title.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('project_title')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step2.title}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step2.titleShort.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('title_abbreviation')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step2.titleShort}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step2.resume.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('project_summary')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step2.result}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step2.context.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('context')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step2.context}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step2.objective.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('objective')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step2.objective}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step2.result.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('expected_result')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step2.result}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step2.amount.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('amount_requested')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step2.amount}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step2.duration.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('implementation_time')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step2.duration}
                                                    </td>
                                                </tr>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='step-title'>
                                                <p>{t('step')} 3</p>
                                            </td>
                                            <td className='step-item-title'>
                                                <tr>
                                                    <div className="lead">{t('step_3_text')} </div>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step3.state.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('state_art')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step3.state}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step3.description.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('brief_description')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step3.description}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step3.advantages.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('advantages')}  </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step3.advantages}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step3.materials.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('materials')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step3.materials}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step3.methodology.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('methodology')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step3.methodology}
                                                    </td>
                                                </tr>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='step-title'>
                                                <p>{t('step')} 4</p>
                                            </td>
                                            <td className='step-item-title'>
                                                <tr>
                                                    <div className="lead">{t('step_4_text')} </div>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step4.activities.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('project_activities')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step4.activities}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step4.calendarUrl.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('text_6_4')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        <a href={step4.calendarUrl} className='deco_null' target="_blank" rel='noreferrer'>
                                                            {t('download')}
                                                        </a>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step4.matrixUrl.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('matrix')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        <a href={step4.matrixUrl} className='deco_null' target="_blank" rel='noreferrer'>
                                                            {t('download')}
                                                        </a>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step4.budgetUrl.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('detailed_budget')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        <a href={step4.budgetUrl} className='deco_null' target="_blank" rel='noreferrer'>
                                                            {t('download')}
                                                        </a>
                                                    </td>
                                                </tr>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='step-title'>
                                                <p>{t('step')} 5</p>
                                            </td>
                                            <td className='step-item-title'>
                                                <tr>
                                                    <div className="lead">{t('step_5_text')} </div>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className='fw-bolder'>{t('means_result')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step5.means}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step5.patentNumber.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('potential_patents')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step5.patentNumber}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className='fw-bolder'>{t('patent_management')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step5.patentManagement}
                                                    </td>
                                                </tr>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='step-title'>
                                                <p>{t('step')} 6</p>
                                            </td>
                                            <td className='step-item-title'>
                                                <tr>
                                                    <div className="lead">{t('step_6_text')} </div>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step6.publishings.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('scientific_publications')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step6.publishings}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step6.patents.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('patents')} </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {step6.patents}
                                                    </td>
                                                </tr>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='step-title'>
                                                <p>{t('step')} 7</p>
                                            </td>
                                            <td className='step-item-title'>
                                                <tr>
                                                    <div className="lead">{t('step_7_text')} </div>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step7.img.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>
                                                            {t('table')}
                                                        </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        <a href={step7.img} className='deco_null' target="_blank" rel="noreferrer">
                                                            {t('download')}
                                                        </a>
                                                    </td>
                                                </tr>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='step-title'>
                                                <p>{t('step')} 8</p>
                                            </td>
                                            <td className='step-item-title'>
                                                <tr>
                                                    <div className="lead">{t('step_8_text')} </div>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step8.partner.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>{t('sme_partner')} ? </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                        {
                                                            step8.partner.includes("yes") ?
                                                            t('yes')
                                                            :
                                                            t('no')
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='table-item'>
                                                        <span className={step8.img.length < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder'
                                                        }>
                                                            {
                                                                step8.partner.includes("yes") ?
                                                                t('cover_letter')
                                                                :
                                                                ''
                                                            }
                                                        </span>
                                                    </td>
                                                    <td className='table-answer'>
                                                            {step8.partner.includes("yes") ? 
                                                                <a href={step8.img} className='deco_null' target="_blank" rel="noreferrer">
                                                                    {t('download')}
                                                                </a>
                                                            : <></>}
                                                        </td>
                                                </tr>
                                            </td>
                                        </tr>
                                    </table>
                                    <div className="d-flex justify-content-between pt-4 banner">
                                        <img src="/assets/partners/OEACP.png" alt="About" className="img-banner pe-2"/>
                                        <img src="/assets/partners/ACP.png" alt="About" className="img-banner pe-2"/>
                                        <img src="/assets/partners/Francophonie.png" alt="About" className="img-banner pe-2"/>
                                        <img src="/assets/partners/UE.jpg" alt="About" className="img-banner"/>
                                    </div>
                                </div>
                                <br />
                                <div className="container">
                                    <h2>Documents de candidature</h2>
                                    <br />
                                    {fileList.map((file) => (
                                        <div>
                                            <h5>{file.path}</h5>
                                            <a href={file.url}>lien de téléchargement</a>
                                            <br /><br />
                                        </div>
                                    ))}
                                </div>
                                <div className="d-flex justify-content-start"></div>
                    <div className="space"/>
                </div>
            </div>
        </div>
    )
}

export default Single;
